import useUIState from 'src/state/ui/persistUiState';
import { ChatActionBarUIState } from 'src/state/ui/types';

export const useChatActionBarUIState = (): ChatActionBarUIState =>
  useUIState((state) => ({
    chatIDList: state.chatIDList,
    addChatToList: (chatId: string) => state.addChatToList(chatId),
    deleteChatFromList: (chatId: string) => state.deleteChatFromList(chatId),
  }));
